<template>
    <div class="verify-form">
      <div class="form-group code">
        <p>Код подтверждения:</p>
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control"
            v-model="code"
            placeholder="######"
            inputmode="numeric"
            pattern="[0-9]*"
            autocomplete="one-time-code"
            @keyup="handleVerifyCode"
          />
          <div class="input-group-append">
            <button class="btn" type="button" @click="handleVerifyCode">Проверить</button>
          </div>
        </div>
        <p v-if="error" class="error">{{errorText}}</p>
      </div>
      <modal-consent-policy-component
        v-model:show="isShowConsentPolicyModal"
        :fields="consentPolicyForm"
        :submit-handler="consentPolicySubmitHandler"
        :loader="isShowConsentPolicyLoader"
      />
    </div>
</template>

<script>
import { inject, ref } from 'vue';
import { useStore } from 'vuex';
import { useCookies } from 'vue3-cookies';
import { verifyCodeRequest, consentPolicyConfirmRequest } from "../../api/auth";
import { useRouter } from 'vue-router';
import { useLog } from "../../services/hooks";
import { AUTH_SET_USER } from "../../store/constants";
import ModalConsentPolicyComponent from "@/components/auth/ModalConsentPolicyComponent.vue";

export default {
  name: 'VerifyFormComponent',
  components: {
    ModalConsentPolicyComponent
  },
  setup() {

    const store = useStore();
    const code = ref('');
    const error = ref(false);
    const errorText = ref('');
    const { cookies } = useCookies();
    const loader = inject('loader');
    const getPhone = inject('getPhone');
    const handleHideAuth = inject('handleHideAuth');
    const router = useRouter();
    const { recordLog } = useLog();
    const consentPolicyForm = ref({
      confirmPolicy1: { value: false, error: '' },
      confirmPolicy2: { value: false, error: '' },
    });
    const isShowConsentPolicyModal = ref(false);
    const isShowConsentPolicyLoader = ref(false);

    const handleVerifyCode = () => {

      if(code.value === '' || code.value.length<6) return;

      recordLog('Отправка кода на верификацию', getPhone());
      const codeValue = code.value;
      loader.value = true;
      error.value = false;
      errorText.value = '';
      isShowConsentPolicyModal.value = false;

      const cookiePolicyConfirmValue = store.getters['cookiePolicy/getValue'];

      verifyCodeRequest({
        code: codeValue,
        phone: getPhone(),
        cookiePolicyConfirmDate: !cookiePolicyConfirmValue ? null : cookiePolicyConfirmValue.datetime
      }).then(response => {
        loader.value = false;
        const data = response.data.data;
        if (data.isConsentPolicyOutdated) {
          console.log(true);
          isShowConsentPolicyModal.value = true;
        } else {
          authorization(data);
        }
      }).catch(err => {
          console.log('err',err);
          loader.value = false;
      });
    };

    const consentPolicySubmitHandler = (e) => {

      e.preventDefault();
      isShowConsentPolicyLoader.value = true;
      consentPolicyForm.value.confirmPolicy1.error = '';
      consentPolicyForm.value.confirmPolicy2.error = '';

      consentPolicyConfirmRequest({
        code: code.value,
        phone: getPhone(),
        confirmPolicy1: consentPolicyForm.value.confirmPolicy1.value,
        confirmPolicy2: consentPolicyForm.value.confirmPolicy2.value,
      }).then(response => {
        isShowConsentPolicyLoader.value = false;
        const data = response.data.data;
        if (data) {
          authorization(data);
        }
      }).catch(err => {
        console.log('err',err);
        isShowConsentPolicyLoader.value = false;
        if (err.response.status === 422) {
          err.response.data.data.map(item => {
            if (item.field === 'confirmPolicy1') {
              consentPolicyForm.value.confirmPolicy1.error = item.message;
            } else if (item.field === 'confirmPolicy2') {
              consentPolicyForm.value.confirmPolicy2.error = item.message;
            }
          })
        }
      });
    };

    const authorization = (data) => {
      code.value = '';
      cookies.set('token', data.token);
      store.commit(AUTH_SET_USER, data.user);
      recordLog('Пользователь успешно авторизовался', getPhone());
      if (store.state.auth.routeTo) {
        router.push(store.state.auth.routeTo);
      } else {
        router.push('/');
      }
      handleHideAuth();
    };

    return {
      code,
      error,
      errorText,
      handleVerifyCode,
      isShowConsentPolicyModal,
      consentPolicyForm,
      consentPolicySubmitHandler,
      isShowConsentPolicyLoader
    }
  }
}
</script>

<style scoped>

  .verify-form {
    margin-top: 10px;
  }

  .form-group label {
    font-weight: 400;
  }

  .form-group.code button {
    font-size: 10px;
    background-color: #3d7fa2;
    color: #ffffff;
    text-transform: uppercase;
  }

  .form-group.code .input-group {
    max-width: 200px;
    margin: 0 auto;
  }

  .form-group.code>p {
    margin-bottom: 5px;
  }

  .form-group:last-child {
    margin-bottom: 0;
  }

  .error {
    max-width: 200px;
    margin: 0 auto;
  }

</style>
